import tableStore from '../store/tableStore';
import { saveAs } from 'file-saver';
import domtoimage from 'dom-to-image';
import { addNotification } from '../action/notificationAction';

/**
 * takes picture of the container and saves the image for the user
 */
export function imageSaver() {
    let target = document.getElementById("container");
    domtoimage.toBlob(target, {height: target.height, width: target.width}).then((blob) => {
        saveAs(blob, `${tableStore.table.tableName}.png`);
    }).catch(() => {
        addNotification({ status: "fail", message: "Could not save image" });
    });
}


// WEBPACK FOOTER //
// ./src/services/imageManager.js